import { render } from "./CitasCompletadas.vue?vue&type=template&id=7f63028a&scoped=true"
import script from "./CitasCompletadas.vue?vue&type=script&lang=js"
export * from "./CitasCompletadas.vue?vue&type=script&lang=js"

import "./CitasCompletadas.vue?vue&type=style&index=0&id=7f63028a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f63028a"]])

export default __exports__